import { isDevEnvironment } from "../environments/isDevEnvironment";

// The Cognito Hosted UI domain is per-user-pool. Preview slots (QA2, QA3, ...)
// reference QA1's pool (they do not have their own), so the Hosted UI subdomain
// for each preview slot must be "qa", not "qa2"/"qa3"/etc. Set
// NEXT_PUBLIC_COGNITO_STAGE=QA on each preview slot's Amplify branch to
// override; defaults to NEXT_PUBLIC_ENV everywhere else.
const cognitoStage = (
  process.env.NEXT_PUBLIC_COGNITO_STAGE ||
  process.env.NEXT_PUBLIC_ENV ||
  "dev"
).replace("_", "-");

// https://dmogdx0jrul3u.cloudfront.net is the CDN for the Zoom Video Web SDK
// https://d3qh7ikisbc007.cloudfront.net is Kemtai's exercise media CDN
const cspHeaderDev = `
default-src 'self';
script-src 'self'  'unsafe-eval' 'unsafe-inline';
script-src-elem 'self' 'unsafe-eval' 'unsafe-inline' https://dmogdx0jrul3u.cloudfront.net https://zoom.us *.zoom.us blob: *.posthog.com; 
style-src 'self' 'unsafe-inline';
style-src-attr 'self' 'unsafe-inline';
frame-src 'self' blob: data: https://*.amazonaws.com https://embed.kemtai.com;
img-src 'self' blob: data: *.amazonaws.com https://d3qh7ikisbc007.cloudfront.net;
font-src 'self' data:;
object-src 'self' https://*.amazonaws.com;
child-src 'self' blob: https://*.amazonaws.com https://embed.kemtai.com;
base-uri 'self';
media-src 'self' blob: data: *.amazonaws.com;
form-action 'self';
frame-ancestors 'none';
block-all-mixed-content;
worker-src blob:;
connect-src
    'self'
    https://cognito-idp.us-east-1.amazonaws.com
    ${process.env.NEXT_PUBLIC_AWS_APPSYNC_GRAPHQLENDPOINT}
    ${process.env.NEXT_PUBLIC_AWS_APPSYNC_GRAPHQLENDPOINT?.replace(
      "https://",
      "wss://"
    ).replace("api", "realtime-api")}
    ${process.env.NEXT_PUBLIC_GATEWAY_URL}
    *.zoom.us
    wss://*.zoom.us
    *.cloudfront.net
    https://*.s3.us-east-1.amazonaws.com
    https://*.amazonaws.com
    *.amazonaws.com
    *.posthog.com
    https://rmh-platform-${cognitoStage}.auth.${process.env.NEXT_PUBLIC_AWS_APPSYNC_REGION}.amazoncognito.com
;
`;

const cspHeaderProd = `
default-src 'self';
script-src 'self' 'unsafe-inline' 'unsafe-eval' https://zoom.us *.zoom.us blob: *.posthog.com https://dmogdx0jrul3u.cloudfront.net; 
style-src 'self' 'unsafe-inline';
style-src-attr 'self' 'unsafe-inline';
frame-src 'self' blob: data: https://*.amazonaws.com https://embed.kemtai.com;
img-src 'self' blob: data: *.amazonaws.com *.zoom.us https://d3qh7ikisbc007.cloudfront.net;
font-src 'self' data: source.zoom.us;
object-src 'self' https://*.amazonaws.com;
child-src 'self' blob: https://*.amazonaws.com https://embed.kemtai.com;
base-uri 'self';
media-src 'self' blob: data: *.amazonaws.com https://*.zoom.us;
form-action 'self';
frame-ancestors 'none';
block-all-mixed-content;
upgrade-insecure-requests;
worker-src blob:;
connect-src
    'self'
    'unsafe-eval'
    https://*.zoom.us
    wss://*.zoom.us
    https://cognito-idp.us-east-1.amazonaws.com
    ${process.env.NEXT_PUBLIC_AWS_APPSYNC_GRAPHQLENDPOINT}
    ${process.env.NEXT_PUBLIC_AWS_APPSYNC_GRAPHQLENDPOINT?.replace(
      "https://",
      "wss://"
    ).replace("api", "realtime-api")}
    ${process.env.NEXT_PUBLIC_GATEWAY_URL}
    *.cloudfront.net
    https://*.s3.us-east-1.amazonaws.com
    https://*.amazonaws.com
    *.amazonaws.com
    *.posthog.com
    https://rmh-platform-${cognitoStage}.auth.${process.env.NEXT_PUBLIC_AWS_APPSYNC_REGION}.amazoncognito.com
;`;

export const getCSPHeader = () => {
  const nonce = Buffer.from(crypto.randomUUID()).toString("base64");

  const cspHeader = isDevEnvironment()
    ? cspHeaderDev.replaceAll("$nonce", nonce)
    : cspHeaderProd.replaceAll("$nonce", nonce);

  const contentSecurityPolicyHeaderValue = cspHeader.replace(/\n/g, "");

  return {
    nonce,
    contentSecurityPolicyHeaderValue,
  };
};
